import styled from 'styled-components/native';

export const CenterIndicator = styled.View`
  width: 20px;
  height: 20px;
  background-color: red;
  position: absolute;
  border-radius: 10000px;
  opacity: 0.5;
`;
